<template>
    <div :id="rootElementId" :style="`height:${PITCH_HEIGHT}px`"></div>
</template>

<script>

import { getDataUrl, getNeutralColors, isWhite } from '../../utils/functions';
import { loadFonts,copyAndAppendElement } from '../../utils/exportToPNG';
import ResizeObserver from 'resize-observer-polyfill';
import Dictionary from '../../dictionary';

  export default {
    name: 'XGChart',
    props: {
      id:{
        type: String,
        required: true
      },
      size: {
        type: Number,
        required: false,
      },
      margin: {
        type: Object,
        required: false,
      },
      shots: {
        // Shots [{"id":1,"x":75.2,"y":67.4,"xG":0.04706717555467873,"min":2,"sec":0,"game":"Valencia - Atletico Madrid","playerId":9,"player":"Jose Gaya","type":"SAVED SHOT","teamName":"Valencia","strategy":"Regular play","bodyPart":"Left footed","homeTeam":true,"penaltyGoal":false,"ownGoal":false,"blockedByOutfielderPlayer":true}]
        type: Array,
        required: true,
      },
      game: {
        // Game like {"gameId":1,"leagueCountryCode":"es","leagueName":"La Liga 2016","matchDate":"02/10/2016","stadiumName":"Mestalla","matchDay":7,"homeTeamId":2,"homeTeamName":"Valencia","homeTeamScore":0,"homeTeamFormation":"4231","homeTeamCoachName":"Salvador González","homeTeamCoachCountryCode":null,"awayTeamId":1,"awayTeamName":"Atletico Madrid","awayTeamScore":2,"awayTeamFormation":"442","awayTeamCoachName":"Diego Simeone","awayTeamCoachCountryCode":"ar","homeTeamGameColor":null,"homeTeamGameSecondColor":null,"awayTeamGameColor":null,"awayTeamGameSecondColor":null,"homeTeamColor":"0xFFFFFF","homeTeamSecondColor":"0x000000","awayTeamColor":"0xFF0000","awayTeamSecondColor":"0xFFFFFF"}
        type: Object,
        required: false
      },
      playerSeasonData: {
        type: Array,
        required: false
      },
      circlesAndBoxes: {
        type: Array,
        required: false
      },
      playerName: {
        type: String,
        required: false
      },
      playerPosition: {
        type: Number,
        required: false
      },
      language: {
        type: String,
        required: true
      },
      homeFillColor:{
        type: String,
        default: "#ffffff"
      },
      homeBorderColor:{
        type: String,
        default: "#000000"
      },
      awayFillColor:{
        type: String,
        default: "#ffffff"
      },
      awayBorderColor:{
        type: String,
        default: "#000000"
      },
      mediaMode:{
        type: Boolean,
        default: false
      },
      postGameAnalysis:{
        type: Boolean,
        default: false
      },
      xGOnTarget:{
        type: Boolean,
        default: false
      },
      finishingXGOT:{
        type: Boolean,
        default: false
      },
      homeTeamName:{
        type: String,
        default: ""
      },
      awayTeamName:{
        type: String,
        default: ""
      },
      team:{
        type: Boolean,
        default: false
      },
      teamOrOpponent: { // At team level we can also show opponent shots: This will be true if showing team and false is showing opponent (Texts change if showing opponent stats)
        type: Boolean,
        default: true
      },
      boxesPercentage:{
        type: String,
        default: 'shots'
      },
      //gameId for print one game Player xG Map
      gameId:{
        type:Number,
        default: 0
      },
      //gameIds for print number of games selected
      gameIds: {
        type: Array,
        required: false,
        default: () => []
      },
      gameName:{
        type: String,
        default: ""
      },
      fontFamily:{
        type: String,
        default: 'NeueMontreal'
      },
      minsPlayed: {
        type: Number,
        default: 0,
      },
      embed:{
        type: Boolean,
        default: false
      },
      showPenalties: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      SVG_WIDTH(){
        return this.size ? this.size : 380;
      },
      PITCH_WIDTH(){
        if(this.margin){
          return this.SVG_WIDTH - this.margin.left - this.margin.right
        }else{
          return this.SVG_WIDTH;
        }
      },
      PITCH_HEIGHT() {
        return this.game ? this.PITCH_WIDTH * 0.67125 : this.PITCH_WIDTH * 0.755
      },
      rootElementId(){
        return `pitchXG${this.id}`
      },
      currentUserFieldColor() {
        return this.$store.getters["auth/fieldColor"];
      },
      totalPenalties() { 
        return this.shots.filter(d => d.penaltyGoal).length;
      },
      totalPenaltyGoals() {
        return this.shots.filter(d => d.penaltyGoal && d.type === "GOAL").length;
      }
    },
    data() {
      return {
        images: {},
        observer: null
      }
    },
    mounted() {
      this.observer = new ResizeObserver(this.onResize).observe(document.getElementById(this.rootElementId));
      this.printD3();
    },
    methods: {
      async printD3(force = false){
        if(force){
          this.images = {};
        }

        const SVG_WIDTH = this.SVG_WIDTH;
        const margin = this.margin ? this.margin : {top: 0, right: 0, bottom: 0, left: 0};

        const PITCH_WIDTH = this.PITCH_WIDTH;
        const PITCH_HEIGHT = this.PITCH_HEIGHT;

        d3.selectAll('.tooltip-no-arrow').remove();

        d3.select(`#${this.rootElementId}`).select("svg").remove();

        const tooltip = d3
          .select("body")
          .append("div")
          .attr("display", "none")
          .attr("class", "tooltip-no-arrow");

        var svg = d3.select(`#${this.rootElementId}`)
          .append("svg")
          .attr("width", SVG_WIDTH)
          .attr("height", PITCH_HEIGHT + margin.top + margin.bottom)
          .style("background-color", "#ffffff")
          .attr("id",`${this.rootElementId}SVG`)
          .attr("class", "pitch");

        this.drawImageBase64(svg, margin.left, margin.top, PITCH_WIDTH, PITCH_HEIGHT, require(`@/assets/img/${this.game ? "": "half_"}pitch_${this.currentUserFieldColor}.png`),"pitch",true);

        // Draw Driblab Logo
        this.drawImageBase64(svg,
          PITCH_WIDTH * 0.75 + margin.left ,
        this.game ? PITCH_HEIGHT * 0.77 + margin.top : PITCH_HEIGHT * 0.785 + margin.top,
        PITCH_WIDTH * 0.16,
        PITCH_HEIGHT * 0.18,
        require(`@/assets/img/driblab${this.mediaMode ? "_normal" : ""}_${this.currentUserFieldColor === 'white' ? 'color' : 'white'}.png`),'logoDriblab');

        let neutralColorsHome = getNeutralColors('home');
        let firstHomeTeamColor = this.homeFillColor;
        let secondHomeTeamColor = this.homeBorderColor;
        let neutralColorsAway = getNeutralColors('away');
        let firstAwayTeamColor =  this.awayFillColor;
        let secondAwayTeamColor = this.awayBorderColor;
        //If is game xG Map but it's post game, don't get team colors, keep neutral colors
        if (this.game && !this.mediaMode && !this.postGameAnalysis) {
          firstHomeTeamColor = this.game.homeTeamGameColor ? this.game.homeTeamGameColor : (this.game.homeTeamColor ? this.game.homeTeamColor : firstHomeTeamColor);
          secondHomeTeamColor = this.game.homeTeamGameSecondColor ? this.game.homeTeamGameSecondColor : (this.game.homeTeamSecondColor ? this.game.homeTeamSecondColor : secondHomeTeamColor);
          firstAwayTeamColor = this.game.awayTeamGameColor ? this.game.awayTeamGameColor : (this.game.awayTeamColor ? this.game.awayTeamColor : firstAwayTeamColor);
          secondAwayTeamColor = this.game.awayTeamGameSecondColor ? this.game.awayTeamGameSecondColor : (this.game.awayTeamSecondColor ? this.game.awayTeamSecondColor : secondAwayTeamColor);
        }
        if(this.game && firstHomeTeamColor === firstAwayTeamColor){
          firstAwayTeamColor = neutralColorsAway[0];
        }
        if(this.game && secondHomeTeamColor === secondAwayTeamColor){
          secondAwayTeamColor = neutralColorsAway[1];
        }

        if (this.circlesAndBoxes && this.circlesAndBoxes.includes("boxes"))
          this.renderBoxes(svg,
            SVG_WIDTH,
            PITCH_HEIGHT,
            margin,
            this.showPenalties ? this.shots.filter(p => !p.ownGoal) : this.shots.filter(p => !p.penaltyGoal).filter(p => !p.ownGoal), //|| this.team
            this.language
          )

        if (this.circlesAndBoxes && this.circlesAndBoxes.includes("circles"))
          this.renderShots(svg,
            PITCH_WIDTH,
            PITCH_HEIGHT,
            margin,
            this.rootElementId,
            this.showPenalties ? this.shots.filter(p => !p.ownGoal) : this.shots.filter(p => !p.penaltyGoal).filter(p => !p.ownGoal), //|| this.team
            this.xGOnTarget,
            this.playerPosition ? this.playerPosition : "none",
            firstHomeTeamColor.replace("0x", "#"),
            secondHomeTeamColor.replace("0x", "#"),
            firstAwayTeamColor.replace("0x", "#"),
            secondAwayTeamColor.replace("0x", "#"),
            tooltip,
            this.game ? true : false);

        if (this.game) {
          this.printGameXGLegend(svg, PITCH_WIDTH, PITCH_HEIGHT, margin, this.shots, this.game, this.language)
          this.printGameLegend(svg, PITCH_WIDTH, PITCH_HEIGHT, margin, firstHomeTeamColor, firstAwayTeamColor, this.game, this.shots)
          this.drawImageBase64(svg, PITCH_WIDTH * 0.08 , PITCH_HEIGHT * 0.92 + margin.top, PITCH_WIDTH * 0.3, PITCH_HEIGHT * 0.07
          , require(`@/assets/img/legend_xg_${this.language === 'en' ? 'english' : 'spanish'}${this.currentUserFieldColor === 'white' ? "_dark": ""}.png`),'legendPitchGame');
        }

        if (!this.game && this.game !== "") {
          this.printPlayerXGLegend(svg, PITCH_WIDTH, margin, this.shots, this.xGOnTarget, this.finishingXGOT, this.playerSeasonData, this.playerName, this.playerPosition ? this.playerPosition : "none",this.language)
          this.drawImageBase64(svg, - PITCH_WIDTH * 0.01 , PITCH_HEIGHT * 0.84 + margin.top, PITCH_WIDTH * 0.38, PITCH_HEIGHT * 0.08
          , require(`@/assets/img/legend_xg_${this.language === 'en' ? 'english' : 'spanish'}${this.currentUserFieldColor === 'white' ? "_dark": ""}_vertical.png`),'legendPitchPlayer');

          if (this.showPenalties) {
            this.writeText(svg, PITCH_WIDTH * 0.0975 , PITCH_HEIGHT * 0.945 + margin.top, "start", (0.0135 * PITCH_WIDTH) + "px", `${this.playerPosition === 1 ? Dictionary[this.language]["finishingMap"]["chart"]["exceptionTextGKPenaltyGoals"] : Dictionary[this.language]["finishingMap"]["chart"]["exceptionTextPenaltyGoals"]}`);
            this.writeText(svg, PITCH_WIDTH * 0.0975 , PITCH_HEIGHT * 0.97 + margin.top, "start", (0.0135 * PITCH_WIDTH) + "px", `${this.totalPenaltyGoals}/${this.totalPenalties} ${ Dictionary[this.language]["team"]["overviewTab"]["stats"]["goalsPenalty"] }`);
          } else {
            this.writeText(svg, PITCH_WIDTH * 0.0975 , PITCH_HEIGHT * 0.945 + margin.top, "start", (0.0135 * PITCH_WIDTH) + "px", `*${ Dictionary[this.language]["finishingMap"]["chart"]["penaltiesExcluded"] }`);
          };
        }
        let font = await loadFonts(this.fontFamily);
        copyAndAppendElement(svg.node(),font.node(),0,0);

        //Emit when is loaded
        this.$emit("loaded", this.id);
      },
      getPlayersWithHighestXG(shots) {
        // Group players by name
        const sumXGShots = shots.reduce(function(acc, val){
          var o = acc.filter(function(obj){
              return obj.player === val.player;
          }).pop() || {player: val.player, xG: 0};

          o.xG += val.xG;
          const index = acc.findIndex(p => p.player === o.player)
          if (index === -1)
            acc.push(o);
          else
            acc[index] = o;
          return acc;
        },[]);
        // Sort, take out players with xG < 0.1 and return first three
        return sumXGShots.sort((a, b) => b.xG - a.xG).filter(p => p.xG >= 0.1).slice(0, 3);
      },
      measureText(string, fontSize = 10) {
        const widths = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.278125,0.278125,0.35625,0.55625,
      		0.55625,0.890625,0.6671875,0.1921875,0.334375,0.334375,0.390625,0.584375,0.278125,0.334375,0.278125,0.303125,0.55625,
      		0.55625,0.55625,0.55625,0.55625,0.55625,0.55625,0.55625,0.55625,0.55625,0.278125,0.278125,0.5859375,0.584375,0.5859375,
      		0.55625,1.015625,0.6671875,0.6671875,0.7234375,0.7234375,0.6671875,0.6109375,0.778125,0.7234375,0.278125,0.5,0.6671875,
      		0.55625,0.834375,0.7234375,0.778125,0.6671875,0.778125,0.7234375,0.6671875,0.6109375,0.7234375,0.6671875,0.9453125,
      		0.6671875,0.6671875,0.6109375,0.278125,0.35625,0.278125,0.478125,0.55625,0.334375,0.55625,0.55625,0.5,0.55625,
      		0.55625,0.278125,0.55625,0.55625,0.2234375,0.2421875,0.5,0.2234375,0.834375,0.55625,0.55625,0.55625,0.55625,
      		0.334375,0.5,0.278125,0.55625,0.5,0.7234375,0.5,0.5,0.5,0.35625,0.2609375,0.3546875,0.590625];
        const avg = 0.5293256578947368;

        return string
          .split('')
          .map(c => c.charCodeAt(0) < widths.length ? widths[c.charCodeAt(0)] : avg)
          .reduce((cur, acc) => acc + cur) * fontSize;
      },
      drawImageBase64(svg,x,y,width,height,img,idName,bottom = false) {
        if(!this.images[idName]){
          let base_image = new Image();
          base_image.crossOrigin = "anonymous";
          base_image.src = img;
          base_image.onload = (event) => {
            const dataUrl = getDataUrl(event.currentTarget);
            this.drawImage(
            svg,
            x,
            y,
            width,
            height,
            dataUrl,
            idName,
            bottom
            );
          }
        }else{
          if(bottom){
            svg.node().insertBefore(this.images[idName],svg.node().firstChild);
          }else{
            svg.node().appendChild(this.images[idName]);
          }
        }
      },
      drawImage: function(svg, x, y, width, height, img,idName,bottom = false) {
        let imgNode = bottom ? svg.insert("svg:image",":first-child") : svg.append("svg:image");
          imgNode.attr("id", idName)
          .attr("x", x)
          .attr("y", y)
          .attr("width", width)
          .attr("height", height)
          .attr("xlink:href", img);
      this.images[idName] = imgNode.node().cloneNode(true);
      },
      drawRectangle(svg, x, y, width, height, color, opacity, className) {
        return svg.append("rect")
          .attr("class", className)
          .attr("x", x)
          .attr("y", y)
          .attr("width", width)
          .attr("height", height)
          .style("fill", color)
          .style("opacity", opacity);
      },
      writeText(svg, x, y, anchor, fontSize, text, fill = "white", className = "none") {
        svg.append("text")
          .attr("x", x)
          .attr("y", y)
          .attr("text-anchor", anchor)
          .attr("dy", "0.8em")
          .attr("font-weight", 500)
          .attr("class", className)
          .style("font-size", fontSize)
          .style("font-family", this.fontFamily)
          .style("fill", fill)
          .text(text);
      },
      getTypeOfShot(name) {
      	if (name === "SAVED SHOT") return "Saved Shot";
      	if (name === "GOAL") return "Goal";
      	if (name === "MISSED SHOT") return "Missed Shot";
      	if (name === "SHOT ON POST") return "Shot on Post";
        if (name === "MISSED CHANCE") return "Chance Missed";
        if (name === "CHANCE MISSED") return "Chance Missed";
        if (name === "Regular play") return "Regular Play";
        if (name && name.startsWith("Individual")) return "Individual Play";
        if (name === "Fast break") return "Fast Break";
        if (name === "From corner") return "From Corner";
        if (name === "Free kick") return "Free Kick";
        if (name === "Set piece") return "Set Piece";
        if (name && name.startsWith("Throw")) return "Throw In";
        if (name === "Left footed") return "Left Foot";
        if (name === "Right footed") return "Right Foot";
        if (name === "Head") return "Head";
        if (name === "Other body part") return "Other Body Part";
        if (name === "Keeper Throw") return "Keeper Throw";
        if (name === "Penalty") return "Penalty";
        console.log("Unkown " + name);
      	return "??";
      },
      renderShots(svg, pitchSize, pitchHeight, margin, elementId, xgShots, xGOnTargetOption, playerPosition, teamColor, strokeColor, awayTeamColor, awayStrokeColor, tooltip, isGameXG = true) {
        if(this.currentUserFieldColor === 'white'){
          if(isWhite(teamColor)){
            teamColor = "#464646"
          }
          if(isWhite(awayTeamColor)){
            awayTeamColor = "#464646"
          }
        }

        let x = d3.scale.linear().domain([0 - (100 * 0.093), 100 + (100 * 0.1)]).range([pitchSize + margin.left, margin.left]);
        let y = d3.scale.linear().domain([0 - (100 * 0.105), 100 + (100 * 0.105)]).range([pitchHeight + margin.top, margin.top]);

        let radius = d3.scale.linear().domain([0, 1]).range([pitchSize * 0.0055, pitchSize * 0.024]);

        var self = this;
        svg.selectAll("circle")
          .data(xgShots)
          .enter()
          .append("circle")
          .attr("r", d => playerPosition === 1 ? radius(d.xG) / 1.5 : radius(d.xG))
          .attr("cx", d => isGameXG ? d.homeTeam ? x(d.x) : x(100 - d.x) : x(d.y))
          .attr("cy", d => isGameXG ? d.homeTeam ? y(100 - d.y) : y(d.y) : y(d.ownGoal ? 100 - d.x : 100 - (100 - d.x) * 2))
          .attr('id', d => "shot" + d.id + "-" + elementId)
          .attr("class", d => "shot-" + d.playerId + " type-" + self.getTypeOfShot(d.type).split(" ").join("-") + " type-" +
              self.getTypeOfShot(d.strategy).split(" ").join("-") + " type-" + self.getTypeOfShot(d.bodyPart).split(" ").join("-") + " season-" + d.seasonId)
          .style("fill-opacity", (d) => self.getTypeOfShot(d.type) === "Goal" ? 0.90 : 0.25)
          .style("opacity", 0.95)
          .style("stroke", d => d.homeTeam ? strokeColor : awayStrokeColor)
          .style("stroke-width", playerPosition === 1 ? pitchSize * 0.002 / 1.5 : pitchSize * 0.0015)
          .style("fill", d => d.homeTeam ? teamColor : awayTeamColor)
          .on('mouseenter',function(xgShot) {
            d3.select(this)
              .transition()
              .duration(300)
              .style("cursor", "pointer")
              .attr('r', playerPosition === 1 ? radius(xgShot.xG) * 3.5 / 3 : radius(xgShot.xG) * 1.75);
            var statName = playerPosition === 1 ? 'xGOT' : 'xG';
            var shotId = document.getElementById("shot" + xgShot.id + "-" + elementId);
            var textLine1 = isGameXG ? xgShot.player : xgShot.game;
            var textLine2 = !isGameXG && playerPosition === 1 ? xgShot.player + " · " + xgShot.xG.toFixed(2) + " " + statName : xgShot.xG.toFixed(2) + " " + statName; // For GK we add shooter name to tooltip
            var textLine3 = self.getTypeOfShot(xgShot.type) + " at " + xgShot.min + ":" + (xgShot.sec < 10 ? "0" + xgShot.sec : xgShot.sec);
            var maxTextWidth = Math.max(self.measureText(textLine1, 14), self.measureText(textLine2, 14), self.measureText(textLine3, 14));
            var widthTooltip = maxTextWidth + 60;
            var height = self.team ? 90 : 70;
            var topOffset = 90;
            var leftOffset = Math.ceil(shotId.getAttribute('r'));
            var tooltipTop = shotId.getBoundingClientRect().bottom + 10;
            tooltipTop = isGameXG && ((xgShot.y <= 50 && xgShot.homeTeam) || (!xgShot.homeTeam && xgShot.y >= 50)) ?
            shotId.getBoundingClientRect().top - topOffset + 10 : tooltipTop

            let tooltipLeft = self.$vuetify.breakpoint.mobile && !self.embed ? (window.innerWidth/2) - (widthTooltip/2) : shotId.getBoundingClientRect().left - (widthTooltip/2) + leftOffset;
            if(self.$vuetify.breakpoint.mobile && !self.embed){
              tooltipTop = d3.select(`#${self.rootElementId}`).node().getBoundingClientRect().top + window.scrollY + (height/2);
            }

            d3.select("body > .tooltip-no-arrow")
            .attr("font-weight", 500)
              .style("width", widthTooltip + "px")
              .style("height", height + "px")
              .style("font-size", "14px")
              .style("left", (tooltipLeft) + "px")
              .style("top", (tooltipTop) + "px")
              .style("display", "inline-block")
              .style("position", "fixed")
              .html("<b>" + (isGameXG ? xgShot.player : xgShot.game)
              + "</b></br>"
              + (self.team ? `${xgShot.player}</br>` : '')
              + (!isGameXG && playerPosition === 1 ? xgShot.player + " · " : "")
              + "<b>" + xgShot.xG.toFixed(2) + " "
              + statName
              + (xGOnTargetOption && xgShot.xgOnTarget > 0.01 ? ' · ' + xgShot.xgOnTarget.toFixed(2) + ' xG OT' : '')
              + "</b></br>" + self.getTypeOfShot(xgShot.type)
              + " at " + xgShot.min + ":"
              + (xgShot.sec < 10 ? "0" + xgShot.sec : xgShot.sec));

            let colorLine = xgShot.homeTeam ? teamColor : awayTeamColor
            colorLine = isGameXG ? colorLine : 'white';

            let xEndShot = xgShot.x1;

            if(xgShot.type === "MISSED SHOT"
              && xgShot.y1 >= 44.2 && xgShot.y1 <= 55.8
              && xgShot.x1 && xgShot.x1 >= 100){
              xEndShot = 104;
            }

            if (self.getTypeOfShot(xgShot.type) !== "Chance Missed") {
              self.drawTrajectoryLine(svg, x, y, xgShot.homeTeam, !isGameXG,xgShot.ownGoal ? 100 - xgShot.x : xgShot.x, xgShot.y, !xEndShot || (xgShot.type === "GOAL" && xEndShot < 100) ? 100 : xEndShot, xgShot.y1, colorLine);
            }

            if(xgShot.type === "GOAL"){
              self.drawGoalCircle(svg, x, y, pitchSize, isGameXG, xgShot.homeTeam, xgShot.id, !xgShot.x1 || xgShot.x1 < 100 ? 100 : xgShot.x1, xgShot.y1, "black", "green");
            }else if(xgShot.type !== "GOAL" && self.getTypeOfShot(xgShot.type) !== "Chance Missed"){
              self.drawFailCross(svg, x, y, pitchSize, isGameXG, xgShot.homeTeam, !xEndShot ? 100 : xEndShot,xgShot.y1, "red");
            }
          })
          .on('mouseout',function(xgShot) {
            d3.select(this)
              .transition()
              .duration(200)
              .attr('r', d => playerPosition === 1 ? radius(d.xG) / 1.5 : radius(d.xG));
            d3.select("body > .tooltip-no-arrow").style("display", "none");
            svg.selectAll(".trajectory-line").remove();
            svg.selectAll(".goal-trajectory-circle").remove();
            svg.selectAll(".fail-cross-line").remove();
          })
          .transition()
          .duration(1000)
      },
      printGameXGLegend(svg, pitchWidth, pitchHeight, margin, shots, gameData, language = "en") {
        let textColor = this.currentUserFieldColor === 'white' ? 'black' : 'white';
        //All home shots (included penalty and own goal)
        let homeShots = shots.filter(s => s.homeTeam);
        //All away shots (included penalty and own goal)
        let awayShots = shots.filter(s => !s.homeTeam);
        //Check all shots (included penalty) to get penalty exception
        let penaltyHomeException = homeShots.some(d => d.penaltyGoal);
        let penaltyAwayException = awayShots.some(d => d.penaltyGoal);
        //Check all shots (included own goals) to get own goal exception
        let ownGoalHomeException = homeShots.some(d => d.ownGoal);
        let ownGoalAwayException = awayShots.some(d => d.ownGoal);
        //Check all shots (included Penalties) to get number of Penalties
        let homePenalties = homeShots.filter(d => d.penaltyGoal).length;
        let awayPenalties = awayShots.filter(d => d.penaltyGoal).length;
        //Check all shots (included own goals) to get number of own goals
        let homeOwnGoals = homeShots.length === 0 ? 0 : homeShots.filter(d => d.ownGoal).length;
        let awayOwnGoals = awayShots.length === 0 ? 0 : awayShots.filter(d => d.ownGoal).length;

        //Remove own goals to count goals and xG
        let homeShotsNoOwnGoals = shots.filter(p => !p.ownGoal).filter(s => s.homeTeam);
        let awayShotsNoOwnGoals = shots.filter(p => !p.ownGoal).filter(s => !s.homeTeam);

        let homeGoals = homeShotsNoOwnGoals.length === 0 ? 0 : homeShotsNoOwnGoals.filter(d => d.type === "GOAL").length;
        let awayGoals = awayShotsNoOwnGoals.length === 0 ? 0 : awayShotsNoOwnGoals.filter(d => d.type === "GOAL").length;

        let homeXG = homeShotsNoOwnGoals.map(shot => shot.xG).reduce((a, b) => a + b, 0);
        let awayXG = awayShotsNoOwnGoals.map(shot => shot.xG).reduce((a, b) => a + b, 0);

        //Count total number of shots without own goals
        const homeShotsNoOwnGoalNumber = homeShotsNoOwnGoals.length;
        const awayShotsNoOwnGoalNumber = awayShotsNoOwnGoals.length;

        const rectangleSize = 0.28 * pitchWidth;

        this.drawRectangle(svg,
          (pitchWidth / 2 - rectangleSize / 2) + margin.left,
          margin.top,
          rectangleSize,
          rectangleSize * 0.35,
          "black",
          0.85,
          "xgLegendRect");
        this.writeText(svg, pitchWidth / 2 + margin.left, 0.012 * pitchWidth + margin.top, "middle", (0.02 * pitchWidth) + "px", Dictionary[this.language]["finishingMap"]["chart"]["sumOfxG"]);
        this.writeText(svg, pitchWidth / 2 + margin.left - 0.095 * pitchWidth, 0.03 * pitchWidth + margin.top, "start", (0.02 * pitchWidth) + "px", `${ homeGoals > homeXG ? '+' : '' }${ (homeGoals - homeXG).toFixed(1) }`, homeGoals > homeXG ? "green" : "red");
        this.writeText(svg, pitchWidth / 2 + margin.left + 0.095 * pitchWidth, 0.03 * pitchWidth + margin.top, "end", (0.02 * pitchWidth) + "px", `${ awayGoals > awayXG ? '+' : '' }${ (awayGoals - awayXG).toFixed(1) }`, awayGoals > awayXG ? "green" : "red");
        this.writeText(svg, pitchWidth / 2 + margin.left, 0.0525 * pitchWidth + margin.top, "middle", (0.04 * pitchWidth) + "px", `${ homeXG.toFixed(1) } ${penaltyHomeException || ownGoalAwayException?'*':''} • ${awayXG.toFixed(1)}${penaltyAwayException || ownGoalHomeException?'*':''}`);

        //Penalty shots and Own Goals not taken into account for players with highest xG
        let homeXGPlayers = this.getPlayersWithHighestXG(homeShots.filter(p => !p.penaltyGoal).filter(p => !p.ownGoal));
        let awayXGPlayers = this.getPlayersWithHighestXG(awayShots.filter(p => !p.penaltyGoal).filter(p => !p.ownGoal));

        homeXGPlayers.forEach((player, i) => {
          this.writeText(svg, pitchWidth * 0.495 + margin.left, (0.108 + (0.024 * i)) * pitchWidth + margin.top, "end", (0.018 * pitchWidth) + "px", `${player.player} · ${player.xG.toFixed(2)}`,textColor);
        });

        awayXGPlayers.forEach((player, i) => {
          this.writeText(svg, pitchWidth * 0.51 + margin.left, (0.108 + (0.024 * i)) * pitchWidth + margin.top, "start", (0.018 * pitchWidth) + "px", `${player.xG.toFixed(2)} · ${player.player}`,textColor);
        });

        let homeXGPershot = isNaN((homeXG / homeShotsNoOwnGoalNumber)) ? 0 : (homeXG / homeShotsNoOwnGoalNumber);
        let awayXGPershot = isNaN((awayXG / awayShotsNoOwnGoalNumber)) ? 0 : (awayXG / awayShotsNoOwnGoalNumber);
        this.writeText(svg,
          pitchWidth * 0.495 + margin.left,
          0.59 * pitchWidth + margin.top,
          "end",
          (0.016 * pitchWidth) + "px",
          `${ homeShotsNoOwnGoalNumber } ${ Dictionary[this.language]["finishingMap"]["chart"]["shots"] } ${homePenalties !== 0 ? '(' + homePenalties + ' P)': ''} · ${homeXGPershot.toFixed(2)} ${ Dictionary[this.language]["finishingMap"]["chart"]["xGPerShot"] }`,
          textColor
        );
        this.writeText(svg,
          pitchWidth * 0.51 + margin.left,
          0.59 * pitchWidth + margin.top,
          "start",
          (0.016 * pitchWidth) + "px",
          `${ awayShotsNoOwnGoalNumber } ${ Dictionary[this.language]["finishingMap"]["chart"]["shots"] } ${awayPenalties !== 0 ? '(' + awayPenalties + ' P)': ''} · ${awayXGPershot.toFixed(2)} ${ Dictionary[this.language]["finishingMap"]["chart"]["xGPerShot"] }`,
          textColor
        );

        // ====================================================================
      	//        Render the Exception Text (For Penalties and Own Goals)
      	// ====================================================================
      	if (penaltyHomeException || penaltyAwayException || ownGoalHomeException || ownGoalAwayException) {

          let exceptionText = ''

          let exceptionTextPenaltyGoals = Dictionary[this.language]["finishingMap"]["chart"]["exceptionTextPenaltyGoals"] + ' (';
          let exceptionTextOwnGoals = Dictionary[this.language]["finishingMap"]["chart"]["exceptionTextOwnGoals"] + ' (';

          if (penaltyHomeException || penaltyAwayException) {
            exceptionText = exceptionTextPenaltyGoals
            if (penaltyHomeException)
              exceptionText += gameData.homeTeamName.trim() + " : " + (homePenalties !== 0 ? homePenalties + ' P': '');
            if (penaltyAwayException)
              exceptionText += (penaltyHomeException ? ', ' : '') + gameData.awayTeamName.trim() + " : " + (awayPenalties !== 0 ? awayPenalties + ' P': '');
          }
          if (ownGoalHomeException || ownGoalAwayException) {
            //If there is previous home exception, then add ' · '
            exceptionText = (penaltyHomeException || penaltyAwayException) ? exceptionText + ")\n " + exceptionTextOwnGoals : exceptionTextOwnGoals;
            if (ownGoalHomeException)
              exceptionText += gameData.homeTeamName.trim() + " : " + (homeOwnGoals !== 0 ? homeOwnGoals + ' ' + Dictionary[this.language]["finishingMap"]["chart"]["og"] : '');
            if (ownGoalAwayException)
              exceptionText += (ownGoalHomeException ? ', ' : '') + gameData.awayTeamName.trim() + " : " + (awayOwnGoals !== 0 ? awayOwnGoals + ' ' + Dictionary[this.language]["finishingMap"]["chart"]["og"] : '');
          }

          exceptionText = exceptionText.trim() + ')';
          let lines = exceptionText.split("\n");

          lines.forEach((line, i) => {
            this.writeText(svg, pitchWidth * 0.92 + margin.left, 0.62 * pitchWidth + margin.top + (0.017 * pitchWidth * i), "end", (0.013 * pitchWidth) + "px", line, textColor);
          });

      	}

      },
      printPlayerXGLegend(svg, pitchWidth, margin, shots, xgOnTargetOption, finishingXGOTOption, seasons, playerName,playerPosition, language = "en") {
        //Remove Penalty and own goals to count goals and xG
        let availableShots = this.showPenalties ? shots.filter(p => !p.ownGoal) : shots.filter(p => !p.penaltyGoal).filter(p => !p.ownGoal); //|| this.team
        const xG = availableShots.map(shot => shot.xG).reduce((a, b) => a + b, 0);
        const xGOnTarget = availableShots.map(shot => shot.xgOnTarget).reduce((a, b) => a + b, 0);
        const finishingXGOT = availableShots.map(shot => shot.finishingXGOT).reduce((a, b) => a + b, 0);
        const shotsOnTarget = availableShots.filter(shot => shot.type === "GOAL").length + availableShots.filter(shot => shot.type === "SAVED SHOT" && !shot.blockedByOutfielderPlayer).length;
        const playerShots = availableShots.length;
        const goals = availableShots.length === 0 ? 0 : availableShots.filter(d => d.type === "GOAL").length;
        //If games of month selected, then get number of games received, if not, take gamesPlayed of seasons
        const games = this.gameIds.length ? this.gameIds.length : seasons.map(s => s.gamesPlayed).reduce((a, b) => a + b, 0);
        const minutes = this.minsPlayed > 0 ? this.minsPlayed : seasons.map(s => s.minutesPlayed).reduce((a, b) => a + b, 0);
        const numberOfSeasons = seasons.length - 1;
        const rectangleSize = 0.16 * pitchWidth + numberOfSeasons * 0.023 * pitchWidth;
        let textColor = this.currentUserFieldColor === 'white' ? 'black' : 'white';
        let xGDecimals = 1;

        if(this.gameId == 0){
          let headerText = `${ Dictionary[this.language]["table"]["history"]["games"] }: ${ games }`;
          if(!this.team){
            //Just show minutes for Player FinishingMap
            headerText += ` · ${ Dictionary[this.language]["table"]["roster"]["minutes"] }: ${ minutes }`;
          }
          this.writeText(svg, pitchWidth * 0.09 + margin.left, 0.045 * pitchWidth + margin.top, "start", (0.019 * pitchWidth) + "px",
           headerText, textColor, "playerGamesAndMinutes");
        }

        this.writeText(svg, pitchWidth * 0.92 + margin.left, 0.045 * pitchWidth + margin.top, "end", (0.019 * pitchWidth) + "px",
        `${ playerShots } ${ Dictionary[this.language]["game"]["stats"]["shots"] } · ${ playerShots > 0 ? (xG / playerShots).toFixed(2) : 0 } xG ${ Dictionary[this.language]["finishingMap"]["perShot"] }`, textColor, "playerShotsAndXG");

        this.drawRectangle(svg,
          (pitchWidth / 2 - 0.45 * pitchWidth / 2) + margin.left, // x
          pitchWidth * 0.58 - numberOfSeasons * 0.023 * pitchWidth, // y
          0.45 * pitchWidth, // width
          rectangleSize, // height
          "black",
          0.85,
          "xgPlayerLegendRect");

        this.writeText(svg, pitchWidth * 0.505 + margin.left, 0.6 * pitchWidth + margin.top - numberOfSeasons * 0.025 * pitchWidth, "middle", (0.026 * pitchWidth) + "px", playerName, "white", "playerXGName");

        svg.selectAll(".leagueAlias")
          .transition()
          .duration(200)
          .style("font-size", "0px");

        if(this.gameId == 0 && this.gameName == ""){
          //Print season's names
          svg.selectAll(".leagueAlias")
            .data(seasons)
            .enter()
            .append("text")
            .attr("class", "leagueAlias")
            .attr("x", pitchWidth / 2 + margin.left)
            .attr("y", (d, i) => i * 0.025 * pitchWidth + (finishingXGOTOption ? 0.64 : 0.65) * pitchWidth + margin.top - (numberOfSeasons * 0.025 * pitchWidth))
            .attr("text-anchor", "middle")
            .attr("dy", "0.8em")
            .attr("font-weight", 500)
            .style("font-size", (0.021 * pitchWidth) + "px")
            .style("font-family", this.fontFamily)
            .style("fill", "white")
            .text(d => d.seasonName);
        }else{
          xGDecimals = 2;
          //Print game name
          this.writeText(svg,
            pitchWidth / 2 + margin.left,
            0.65 * pitchWidth + margin.top,
            "middle",
            (0.021 * pitchWidth) + "px",
            this.gameName,
            "white",
            "gameName"
          );

        }

        let statName = playerPosition === 1 ? 'xGOT' : (this.teamOrOpponent ? Dictionary[this.language]["playerScout"]["xG"] : Dictionary[this.language]["statsNaming"]["xGAgainst"]);
        this.writeText(svg,
          pitchWidth * 0.505 + margin.left,
          finishingXGOTOption ? 0.68 * pitchWidth + margin.top  : 0.7 * pitchWidth + margin.top,
          "middle",
          (0.023 * pitchWidth) + "px",
          `${ goals } ${ this.teamOrOpponent ? Dictionary[this.language]["table"]["roster"]["goals"] : Dictionary[this.language]["playerScout"]["goalsConceded"] } ${this.showPenalties && this.totalPenaltyGoals > 0 ? `(${this.totalPenaltyGoals} P)` : ''} · ${ xG.toFixed(xGDecimals) } ${statName} ${xgOnTargetOption ? '· ' + xGOnTarget.toFixed(xGDecimals) + ' xG OT' : '' }`,
          "white",
          "playerXGandGoals"
        );

        if (finishingXGOTOption && shotsOnTarget > 0) {
          this.writeText(svg,
            pitchWidth * 0.505 + margin.left,
            0.71 * pitchWidth + margin.top,
            "middle",
            (0.023 * pitchWidth) + "px",
            `${ (finishingXGOT / shotsOnTarget) > 1 ? '+': ''}${ (((finishingXGOT / shotsOnTarget) - 1) * 100 ).toFixed(1) }% ${ Dictionary[this.language]["statsNaming"]["Finishing"] } xG OT`,
            "white",
            "playerXGandGoals"
          );
        }

      },
      printGameLegend(svg, pitchSize, pitchHeight, margin, homeTeamColor, awayTeamColor, gameData, shots, language = "en") {

        let homeScore = this.game.homeTeamScore;
        let awayScore = this.game.awayTeamScore;

        let secondHomeTeamColor = this.homeBorderColor;
        let neutralColorsAway = getNeutralColors('away');
        let secondAwayTeamColor = this.game ? neutralColorsAway[1] : this.awayBorderColor;

        let textColor = this.currentUserFieldColor === 'white' ? 'black' : 'white';

        let rectHome = this.drawRectangle(svg,
          0.045 * pitchSize + margin.left,
          margin.top - 3,
          16,
          (0.075 * pitchHeight) + 5,
          homeTeamColor.replace("0x", "#"), 0.9, "gameLegend1");
        rectHome
        .style("border-radius",'3px')
        .style("border",`1px solid ${secondHomeTeamColor}`)
        .style("opacity",0.95)
        .style("stroke-width",1)
        .style("stroke",`${secondHomeTeamColor}`)
        .attr("rx",3)
        .attr("ry",3)

        this.drawImageBase64(svg,
          0.07 * pitchSize + margin.left,
          0.03 * pitchHeight + margin.top,
          0.05 * pitchSize,
          0.05 * pitchHeight,
          'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' + gameData.homeTeamId + '.png','homeCrest');
        this.writeText(svg,
          0.115 * pitchSize + margin.left,
          0.04 * pitchHeight + margin.top,
          "start",
          (0.022 * pitchSize) + "px",
          `${ this.homeTeamName } • ` + homeScore,textColor);

        let rectAway = this.drawRectangle(svg,
          0.935 * pitchSize + margin.left,
          margin.top - 3,
          16,
          (0.075 * pitchHeight) + 5,
          awayTeamColor.replace("0x", "#"), 0.9, "gameLegend1");
        rectAway
        .style("border-radius",'3px')
        .style("border",`1px solid ${secondAwayTeamColor}`)
        .style("opacity",0.95)
        .style("stroke-width",1)
        .style("stroke",`${secondAwayTeamColor}`)
        .attr("rx",3)
        .attr("ry",3)

        this.drawImageBase64(svg,
          0.885 * pitchSize + margin.left,
          0.03 * pitchHeight + margin.top,
          0.05 * pitchSize,
          0.05 * pitchHeight,
          'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' + gameData.awayTeamId + '.png');
        this.writeText(svg,
          0.89 * pitchSize + margin.left,
          0.04 * pitchHeight + margin.top,
          "end",
          (0.022 * pitchSize) + "px",
          awayScore + ` • ${ this.awayTeamName }`,textColor);

      },
      renderBoxes(svg, svgWidth, pitchHeight, margin, shots, language = 'en') {
        let textColor = this.currentUserFieldColor === 'white' ? 'black' : 'white';

        const shotLegend = Dictionary[this.language]["statsNaming"]["Shots"].toLowerCase();

        const goalArea = shots.filter(s => s.x >= 94.2 && s.y >= 36.8 && s.y <= 63.2);
        const boxRight = shots.filter(s => s.x >= 83 && s.y >= 21.1 && s.y < 36.8);
        const boxCenter = shots.filter(s => s.x >= 83 && s.x < 94.2 && s.y >= 36.8 && s.y <= 63.2);
        const boxLeft = shots.filter(s => s.x >= 83 && s.y > 63.2 && s.y < 78.9);
        //Out Of Box
        const outBoxDeepRight = shots.filter(s => s.x >= 83 && s.y < 21.1);
        const outBoxDeepLeft = shots.filter(s => s.x >= 83 && s.y > 78.9);
        const outBoxRight = shots.filter(s => s.x >= 65 && s.x < 83 && s.y < 21.1);
        const outBoxCentreRight = shots.filter(s => s.x >= 65 && s.x < 83 && s.y >= 21.1 && s.y <= 35.5);
        const outBoxCentre = shots.filter(s => s.x >= 65 && s.x < 83 && s.y >= 35.6 && s.y <= 64.4);
        const outBoxCentreLeft = shots.filter(s => s.x >= 65 && s.x < 83 && s.y >= 64.5 && s.y <= 78.9);
        const outBoxLeft = shots.filter(s => s.x >= 65 && s.x < 83 && s.y > 78.9);
        //+35
        const right35 = shots.filter(s => s.x >= 50 && s.x < 65 && s.y < 21.1);
        const centreRight35 = shots.filter(s => s.x >= 50 && s.x < 65 && s.y >= 21.1 && s.y <= 35.5);
        const centre35 = shots.filter(s => s.x >= 50 && s.x < 65 && s.y >= 35.6 && s.y <= 64.4);
        const centreLeft35 = shots.filter(s => s.x >= 50 && s.x < 65 && s.y >= 64.5 && s.y <= 78.9);
        const left35 = shots.filter(s => s.x >= 50 && s.x < 65 && s.y > 78.9);

        var shadowScale = d3.scale.linear().domain([0, shots.length]).range([0.1, 0.75]);

        const xgTotal = _.reduce(shots,(accum,s) => accum += s.xG,0)
        let currentXG;
        let pct;

        if (outBoxDeepLeft.length > 0.5) {
          currentXG = _.reduce(outBoxDeepLeft,(acccum,s) => { return acccum += s.xG;},0).toFixed(2)
          pct = this.boxesPercentage === 'shots' ? Math.round(outBoxDeepLeft.length / shots.length * 100) : Math.round(currentXG / xgTotal * 100);
          this.drawRectangle(svg, 0.094 * svgWidth, 0.105 * pitchHeight, 0.155 * svgWidth, 0.25 * pitchHeight, "red", shadowScale(outBoxDeepLeft.length), "gameLegend1");
          this.writeText(svg, 0.177 * svgWidth, 0.2 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `${ pct } %`,textColor);
          this.writeText(svg, 0.177 * svgWidth, 0.23 * pitchHeight, "middle", (0.018 * svgWidth) + "px",`(${ Math.round(outBoxDeepLeft.length) } ${ shotLegend })`,textColor);
          this.writeText(svg, 0.177 * svgWidth, 0.26 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `(${currentXG} xG)`,textColor);
          this.writeText(svg, 0.177 * svgWidth, 0.29 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `${((outBoxDeepLeft.filter(s => s.type === "GOAL").length / outBoxDeepLeft.length) * 100).toFixed(0)}% ${ Dictionary[this.language]["statsNaming"]["Finishing"] }`,textColor);
        }
        if (outBoxLeft.length > 0.5) {
          currentXG = _.reduce(outBoxLeft,(acccum,s) => { return acccum += s.xG;},0).toFixed(2)
          pct = this.boxesPercentage === 'shots' ? Math.round(outBoxLeft.length / shots.length * 100) : Math.round(currentXG / xgTotal * 100);
          this.drawRectangle(svg, 0.094 * svgWidth, 0.365 * pitchHeight, 0.155 * svgWidth, 0.295 * pitchHeight, "red", shadowScale(outBoxLeft.length), "gameLegend1");
          this.writeText(svg, 0.177 * svgWidth, 0.46 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `${ pct } %`,textColor);
          this.writeText(svg, 0.177 * svgWidth, 0.49 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `(${ Math.round(outBoxLeft.length) } ${ shotLegend })`,textColor);
          this.writeText(svg, 0.177 * svgWidth, 0.52 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `(${currentXG} xG)`,textColor);
          this.writeText(svg, 0.177 * svgWidth, 0.55 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `${((outBoxLeft.filter(s => s.type === "GOAL").length / outBoxLeft.length) * 100).toFixed(0)}% ${ Dictionary[this.language]["statsNaming"]["Finishing"] }`,textColor);
        }
        if (left35.length > 0.5) {
          currentXG = _.reduce(left35,(acccum,s) => { return acccum += s.xG;},0).toFixed(2)
          pct = this.boxesPercentage === 'shots' ? Math.round(left35.length / shots.length * 100) : Math.round(currentXG / xgTotal * 100);
          this.drawRectangle(svg, 0.094 * svgWidth, 0.665 * pitchHeight, 0.155 * svgWidth, 0.24 * pitchHeight, "red", shadowScale(left35.length), "gameLegend1");
          this.writeText(svg, 0.177 * svgWidth, 0.735 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `${ pct } %`,textColor);
          this.writeText(svg, 0.177 * svgWidth, 0.765 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `(${ Math.round(left35.length) } ${ shotLegend })`,textColor);
          this.writeText(svg, 0.177 * svgWidth, 0.795 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `(${currentXG} xG)`,textColor);
          this.writeText(svg, 0.177 * svgWidth, 0.825 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `${((left35.filter(s => s.type === "GOAL").length / left35.length) * 100).toFixed(0)}% ${ Dictionary[this.language]["statsNaming"]["Finishing"] }`,textColor);
        }
        if (outBoxDeepRight.length > 0.5) {
          currentXG = _.reduce(outBoxDeepRight,(acccum,s) => { return acccum += s.xG;},0).toFixed(2)
          pct = this.boxesPercentage === 'shots' ? Math.round(outBoxDeepRight.length / shots.length * 100) : Math.round(currentXG / xgTotal * 100);
          this.drawRectangle(svg, 0.76 * svgWidth, 0.105 * pitchHeight, 0.155 * svgWidth, 0.25 * pitchHeight, "red", shadowScale(outBoxDeepRight.length), "gameLegend1");
          this.writeText(svg, 0.842 * svgWidth, 0.2 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `${ pct } %`,textColor);
          this.writeText(svg, 0.842 * svgWidth, 0.23 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `(${ Math.round(outBoxDeepRight.length) } ${ shotLegend })`,textColor);
          this.writeText(svg, 0.842 * svgWidth, 0.26 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `(${currentXG} xG)`,textColor);
          this.writeText(svg, 0.842 * svgWidth, 0.29 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `${((outBoxDeepRight.filter(s => s.type === "GOAL").length / outBoxDeepRight.length) * 100).toFixed(0)}% ${ Dictionary[this.language]["statsNaming"]["Finishing"] }`,textColor);
        }
        if (outBoxRight.length > 0.5) {
          currentXG = _.reduce(outBoxRight,(acccum,s) => { return acccum += s.xG;},0).toFixed(2)
          pct = this.boxesPercentage === 'shots' ? Math.round(outBoxRight.length / shots.length * 100) : Math.round(currentXG / xgTotal * 100);
          this.drawRectangle(svg, 0.76 * svgWidth, 0.365 * pitchHeight, 0.155 * svgWidth, 0.295 * pitchHeight, "red", shadowScale(outBoxRight.length), "gameLegend1");
          this.writeText(svg, 0.842 * svgWidth, 0.46 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `${ pct } %`,textColor);
          this.writeText(svg, 0.842 * svgWidth, 0.49 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `(${ Math.round(outBoxRight.length) } ${ shotLegend })`,textColor);
          this.writeText(svg, 0.842 * svgWidth, 0.52 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `(${currentXG} xG)`,textColor);
          this.writeText(svg, 0.842 * svgWidth, 0.55 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `${((outBoxRight.filter(s => s.type === "GOAL").length / outBoxRight.length) * 100).toFixed(0)}% ${ Dictionary[this.language]["statsNaming"]["Finishing"] }`,textColor);
        }
        if (right35.length > 0.5) {
          currentXG = _.reduce(right35,(acccum,s) => { return acccum += s.xG;},0).toFixed(2)
          pct = this.boxesPercentage === 'shots' ? Math.round(right35.length / shots.length * 100) : Math.round(currentXG / xgTotal * 100);
          this.drawRectangle(svg, 0.76 * svgWidth, 0.665 * pitchHeight, 0.155 * svgWidth, 0.24 * pitchHeight, "red", shadowScale(right35.length), "gameLegend1");
          this.writeText(svg, 0.842 * svgWidth, 0.735 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `${ pct } %`,textColor);
          this.writeText(svg, 0.842 * svgWidth, 0.765 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `(${ Math.round(right35.length) } ${ shotLegend })`,textColor);
          this.writeText(svg, 0.842 * svgWidth, 0.795 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `(${currentXG} xG)`,textColor);
          this.writeText(svg, 0.842 * svgWidth, 0.825 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `${((right35.filter(s => s.type === "GOAL").length / right35.length) * 100).toFixed(0)}% ${ Dictionary[this.language]["statsNaming"]["Finishing"] }`,textColor);
        }

        if (outBoxCentreLeft.length > 0.5) {
          currentXG = _.reduce(outBoxCentreLeft,(acccum,s) => { return acccum += s.xG;},0).toFixed(2)
          pct = this.boxesPercentage === 'shots' ? Math.round(outBoxCentreLeft.length / shots.length * 100) : Math.round(currentXG / xgTotal * 100);
          this.drawRectangle(svg, 0.254 * svgWidth, 0.365 * pitchHeight, 0.13 * svgWidth, 0.295 * pitchHeight, "red", shadowScale(outBoxCentreLeft.length), "gameLegend1");
          this.writeText(svg, 0.33 * svgWidth, 0.46 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `${ pct } %`,textColor);
          this.writeText(svg, 0.33 * svgWidth, 0.49 * pitchHeight, "middle", (0.018 * svgWidth) + "px",`(${ Math.round(outBoxCentreLeft.length) } ${ shotLegend })`,textColor);
          this.writeText(svg, 0.33 * svgWidth, 0.52 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `(${currentXG} xG)`,textColor);
          this.writeText(svg, 0.33 * svgWidth, 0.55 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `${((outBoxCentreLeft.filter(s => s.type === "GOAL").length / outBoxCentreLeft.length) * 100).toFixed(0)}% ${ Dictionary[this.language]["statsNaming"]["Finishing"] }`,textColor);
        }
        if (outBoxCentre.length > 0.5) {
          currentXG = _.reduce(outBoxCentre,(acccum,s) => { return acccum += s.xG;},0).toFixed(2)
          pct = this.boxesPercentage === 'shots' ? Math.round(outBoxCentre.length / shots.length * 100) : Math.round(currentXG / xgTotal * 100);
          this.drawRectangle(svg, 0.39 * svgWidth, 0.365 * pitchHeight, 0.23 * svgWidth, 0.295 * pitchHeight, "red", shadowScale(outBoxCentre.length), "gameLegend1");
          this.writeText(svg, 0.505 * svgWidth, 0.46 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `${ pct } % ${ Dictionary[this.language]["game"]["gamePossessionMap"]["of"] } ${this.boxesPercentage === 'shots' ? Dictionary[this.language]["statsNaming"]["Shots"] : 'xG'}`,textColor);
          this.writeText(svg, 0.505 * svgWidth, 0.49 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `(${ Math.round(outBoxCentre.length) } ${ shotLegend } · ${currentXG} xG)`,textColor);
          this.writeText(svg, 0.505 * svgWidth, 0.52 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `${((outBoxCentre.filter(s => s.type === "GOAL").length / outBoxCentre.length) * 100).toFixed(0)}% ${ Dictionary[this.language]["statsNaming"]["Finishing"] }`,textColor);
        }
        if (outBoxCentreRight.length > 0.5) {
          currentXG = _.reduce(outBoxCentreRight,(acccum,s) => { return acccum += s.xG;},0).toFixed(2)
          pct = this.boxesPercentage === 'shots' ? Math.round(outBoxCentreRight.length / shots.length * 100) : Math.round(currentXG / xgTotal * 100);
          this.drawRectangle(svg, 0.625 * svgWidth, 0.365 * pitchHeight, 0.13 * svgWidth, 0.295 * pitchHeight, "red", shadowScale(outBoxCentreRight.length), "gameLegend1");
          this.writeText(svg, 0.69 * svgWidth, 0.46 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `${ pct } %`,textColor);
          this.writeText(svg, 0.69 * svgWidth, 0.49 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `(${ Math.round(outBoxCentreRight.length) } ${ shotLegend })`,textColor);
          this.writeText(svg, 0.69 * svgWidth, 0.52 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `(${currentXG} xG)`,textColor);
          this.writeText(svg, 0.69 * svgWidth, 0.55 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `${((outBoxCentreRight.filter(s => s.type === "GOAL").length / outBoxCentreRight.length) * 100).toFixed(0)}% ${ Dictionary[this.language]["statsNaming"]["Finishing"] }`,textColor);
        }

        if (centreLeft35.length > 0.5) {
          currentXG = _.reduce(centreLeft35,(acccum,s) => { return acccum += s.xG;},0).toFixed(2)
          pct = this.boxesPercentage === 'shots' ? Math.round(centreLeft35.length / shots.length * 100) : Math.round(currentXG / xgTotal * 100);
          this.drawRectangle(svg, 0.254 * svgWidth, 0.665 * pitchHeight, 0.13 * svgWidth, 0.24 * pitchHeight, "red", shadowScale(centreLeft35.length), "gameLegend1");
          this.writeText(svg, 0.33 * svgWidth, 0.69 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `${ pct } %`,textColor);
          this.writeText(svg, 0.33 * svgWidth, 0.72 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `(${ Math.round(centreLeft35.length) } ${ shotLegend })`,textColor);
          this.writeText(svg, 0.33 * svgWidth, 0.75 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `(${currentXG} xG)`,textColor);
          this.writeText(svg, 0.33 * svgWidth, 0.78 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `${((centreLeft35.filter(s => s.type === "GOAL").length / centreLeft35.length) * 100).toFixed(0)}% ${ Dictionary[this.language]["statsNaming"]["Finishing"] }`,textColor);
        }

        if (centre35.length > 0.5) {
          currentXG = _.reduce(centre35,(acccum,s) => { return acccum += s.xG;},0).toFixed(2)
          pct = this.boxesPercentage === 'shots' ? Math.round(centre35.length / shots.length * 100) : Math.round(currentXG / xgTotal * 100);
          this.drawRectangle(svg, 0.39 * svgWidth, 0.665 * pitchHeight, 0.23 * svgWidth, 0.24 * pitchHeight, "red", shadowScale(centre35.length), "gameLegend1");
          this.writeText(svg, 0.505 * svgWidth, 0.69 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `${ pct } % ${ Dictionary[this.language]["game"]["gamePossessionMap"]["of"] } ${this.boxesPercentage === 'shots' ? Dictionary[this.language]["statsNaming"]["Shots"] : 'xG'}`,textColor);
          this.writeText(svg, 0.505 * svgWidth, 0.72 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `(${ Math.round(centre35.length) } ${ shotLegend } · ${currentXG} xG)`,textColor);
          this.writeText(svg, 0.505 * svgWidth, 0.75 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `${((centre35.filter(s => s.type === "GOAL").length / centre35.length) * 100).toFixed(0)}% ${ Dictionary[this.language]["statsNaming"]["Finishing"] }`,textColor);
        }
        if (centreRight35.length > 0.5) {
          currentXG = _.reduce(centreRight35,(acccum,s) => { return acccum += s.xG;},0).toFixed(2)
          pct = this.boxesPercentage === 'shots' ? Math.round(centreRight35.length / shots.length * 100) : Math.round(currentXG / xgTotal * 100);
          this.drawRectangle(svg, 0.625 * svgWidth, 0.665 * pitchHeight, 0.13 * svgWidth, 0.24 * pitchHeight, "red", shadowScale(centreRight35.length), "gameLegend1");
          this.writeText(svg, 0.69 * svgWidth, 0.69 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `${ pct } %`,textColor);
          this.writeText(svg, 0.69 * svgWidth, 0.72 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `(${ Math.round(centreRight35.length) } ${ shotLegend })`,textColor);
          this.writeText(svg, 0.69 * svgWidth, 0.75 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `(${currentXG} xG)`,textColor);
          this.writeText(svg, 0.69 * svgWidth, 0.78 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `${((centreRight35.filter(s => s.type === "GOAL").length / centreRight35.length) * 100).toFixed(0)}% ${ Dictionary[this.language]["statsNaming"]["Finishing"] }`,textColor);
        }
        if (boxLeft.length > 0.5) {
          currentXG = _.reduce(boxLeft,(acccum,s) => { return acccum += s.xG;},0).toFixed(2)
          pct = this.boxesPercentage === 'shots' ? Math.round(boxLeft.length / shots.length * 100) : Math.round(currentXG / xgTotal * 100);
          this.drawRectangle(svg, 0.265 * svgWidth, 0.105 * pitchHeight, 0.12 * svgWidth, 0.24 * pitchHeight, "red", shadowScale(boxLeft.length), "gameLegend1");
          this.writeText(svg, 0.33 * svgWidth, 0.20 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `${ pct } %`,textColor);
          this.writeText(svg, 0.33 * svgWidth, 0.23 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `(${ Math.round(boxLeft.length) } ${ shotLegend })`,textColor);
          this.writeText(svg, 0.33 * svgWidth, 0.26 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `(${currentXG} xG)`,textColor);
          this.writeText(svg, 0.33 * svgWidth, 0.29 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `${((boxLeft.filter(s => s.type === "GOAL").length / boxLeft.length) * 100).toFixed(0)}% ${ Dictionary[this.language]["statsNaming"]["Finishing"] }`,textColor);
        }
        if (boxRight.length > 0.5) {
          currentXG = _.reduce(boxRight,(acccum,s) => { return acccum += s.xG;},0).toFixed(2)
          pct = this.boxesPercentage === 'shots' ? Math.round(boxRight.length / shots.length * 100) : Math.round(currentXG / xgTotal * 100);
          this.drawRectangle(svg, 0.625 * svgWidth, 0.105 * pitchHeight, 0.12 * svgWidth, 0.24 * pitchHeight, "red", shadowScale(boxRight.length), "gameLegend1");
          this.writeText(svg, 0.69 * svgWidth, 0.20 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `${ pct } %`,textColor);
          this.writeText(svg, 0.69 * svgWidth, 0.23 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `(${ Math.round(boxRight.length) } ${ shotLegend })`,textColor);
          this.writeText(svg, 0.69 * svgWidth, 0.26 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `(${currentXG} xG)`,textColor);
          this.writeText(svg, 0.69 * svgWidth, 0.29 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `${((boxRight.filter(s => s.type === "GOAL").length / boxRight.length) * 100).toFixed(0)}% ${ Dictionary[this.language]["statsNaming"]["Finishing"] }`,textColor);
        }
        if (goalArea.length > 0.5) {
          currentXG = _.reduce(goalArea,(acccum,s) => { return acccum += s.xG;},0).toFixed(2)
          pct = this.boxesPercentage === 'shots' ? Math.round(goalArea.length / shots.length * 100) : Math.round(currentXG / xgTotal * 100);
          this.drawRectangle(svg, 0.4 * svgWidth, 0.105 * pitchHeight, 0.21 * svgWidth, 0.068 * pitchHeight, "red", shadowScale(goalArea.length), "gameLegend1");
          this.writeText(svg, 0.505 * svgWidth, 0.11 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `${ pct } % ${ Dictionary[this.language]["game"]["gamePossessionMap"]["of"] } ${this.boxesPercentage === 'shots' ? Dictionary[this.language]["statsNaming"]["Shots"] : 'xG'}`,textColor);
          this.writeText(svg, 0.505 * svgWidth, 0.14 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `(${ Math.round(goalArea.length) } ${ shotLegend } · ${currentXG} xG)`,textColor);
        }
        if (boxCenter.length > 0.5) {
          currentXG = _.reduce(boxCenter,(acccum,s) => { return acccum += s.xG;},0).toFixed(2)
          pct = this.boxesPercentage === 'shots' ? Math.round(boxCenter.length / shots.length * 100) : Math.round(currentXG / xgTotal * 100);
          this.drawRectangle(svg, 0.39 * svgWidth, 0.19 * pitchHeight, 0.23 * svgWidth, 0.155 * pitchHeight, "red", shadowScale(boxCenter.length), "gameLegend1");
          this.writeText(svg, 0.505 * svgWidth, 0.2 * pitchHeight, "middle", (0.018 * svgWidth) + "px", `${ pct } % ${ Dictionary[this.language]["game"]["gamePossessionMap"]["of"] } ${this.boxesPercentage === 'shots' ? Dictionary[this.language]["statsNaming"]["Shots"] : 'xG'}`,textColor);
          this.writeText(svg, 0.505 * svgWidth, 0.23 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `(${ Math.round(boxCenter.length) } ${ shotLegend } · ${currentXG} xG)`,textColor);
          this.writeText(svg, 0.505 * svgWidth, 0.26 * pitchHeight, "middle", (0.018 * svgWidth) + "px",
          `${((boxCenter.filter(s => s.type === "GOAL").length / boxCenter.length) * 100).toFixed(0)}% ${Dictionary[this.language]["statsNaming"]["Finishing"] }`,textColor);
        }

      },
      drawTrajectoryLine(svg,xScale,yScale,isHomeTeam, isPlayer, x0, y0, x1, y1, strokeColor = "black") {
        let sx0;
        let sy0;
        let sx1;
        let sy1;
        if (isPlayer) {
          sx0 = xScale(y0);
          sy0 = yScale(100 - (100 - x0) * 2);
          sx1 = xScale(y1);
          sy1 = yScale(2 * x1 - 100);
        } else if (isHomeTeam) {
          sx0 = xScale(x0);
          sy0 = yScale(100 - y0);
          sx1 = xScale(x1);
          sy1 = yScale(100 - y1);
        } else {
          sx0 = xScale(100 - x0);
          sy0 = yScale(y0);
          sx1 = xScale(100 - x1);
          sy1 = yScale(y1);
        }

        return svg.append("line")
          .attr("x1", sx0)
          .attr("y1", sy0)
          .attr("x2", sx1)
          .attr("y2", sy1)
          .attr("stroke-width", 1.5)
          .attr("class", "trajectory-line")
          .style("opacity", 1)
          .attr("stroke", strokeColor);
      },
      drawGoalCircle(svg, scaleX, scaleY, pitchSize, isGame, isHomeTeam, id, x, y, strokeColor, fillColor){
        svg
          .append("circle")
          .attr("r", d => 5)
          .attr("cx", d => isGame ? isHomeTeam ? scaleX(x) : scaleX(100 - x) : scaleX(y))
          .attr("cy", d => isGame ? isHomeTeam ? scaleY(100 - y) : scaleY(y) : scaleY(100 - (100 - x) * 2))
          .attr('id', d => "goal-trajectory-circle-" + id)
          .attr("class", d => "goal-trajectory-circle")
          .style("fill-opacity", (d) => 0.88)
          .style("opacity", 0.95)
          .style("stroke", d => strokeColor)
          .style("stroke-width", pitchSize * 0.0015)
          .style("fill", d => fillColor)
      },
      drawFailCross(svg, scaleX, scaleY, pitchSize, isGame, isHomeTeam, x, y, strokeColor){
        let offsetX = isGame ? 0.9 : 1.4;
        let offsetY = isGame ? 2 : 1;
        let sx0;
        let sy0;
        let sx1;
        let sy1;
        if (!isGame) {
          sx0 = scaleX(y + offsetY);
          sy0 = scaleY(100 - (100 - x - offsetX) * 2);
          sx1 = scaleX(y - offsetY);
          sy1 = scaleY(2 * x - 100 - offsetX);
        } else if (isHomeTeam) {
          sx0 = scaleX(x + offsetX);
          sy0 = scaleY(100 - y - offsetY);
          sx1 = scaleX(x - offsetX);
          sy1 = scaleY(100 - y + offsetY);
        } else {
          sx0 = scaleX(100 - x + offsetX);
          sy0 = scaleY(y - offsetY);
          sx1 = scaleX(100 - x - offsetX);
          sy1 = scaleY(y + offsetY);
        }

        svg.append('path')
        .attr("d", d3.svg.symbol().type('cross').size(pitchSize * 0.2))
        .attr('stroke', strokeColor)
        .attr('fill', strokeColor)
        .attr('stroke-width', 0.1)
        .attr("transform", function(d) { return "translate(" + ((sx0 + sx1) / 2 ) + "," + ((sy0 + sy1) / 2 ) + ") rotate(-45)"; })
        .attr("class", "fail-cross-line");

      },
      onResize(){
        let elto =document.getElementById(this.rootElementId);
        if(elto){
          this.$emit("sizeChange", {height:elto.clientHeight,width:elto.clientWidth});
        }
      }
    },
    destroyed() {
      delete this.observer;
      d3.select(`#${this.rootElementId}`).select("svg").remove();
    },
  }

</script>



// WEBPACK FOOTER //
// src/views/base/XGChart.vue